<template>
  <div :class="bgLeftClass" class="rounded-md p-4">
    <div class="flex">
      <div class="flex-shrink-0 mt-1 h-5 w-5">
        <b-icon :class="iconColor" size="is-small" :icon="iconName" />
      </div>
      <div :class="iconColor" class="ml-3 text-sm leading-1">
        <slot />
      </div>
      <button v-if="isClosable" @click="$emit('close')" class="ml-auto inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150">
        <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    type: {
      type: String,
      default: 'info',
      validator (value) {
        return ['info', 'success', 'warning', 'error'].includes(value)
      }
    },
    isClosable: Boolean
  },
  computed: {
    iconName () {
      switch (this.type) {
        case 'info':
          return 'info-circle'
        case 'success':
          return 'check-circle'
        case 'warning':
          return 'exclamation-triangle'
        case 'error':
          return 'exclamation-circle'
        default:
          return 'info-circle'
      }
    },
    bgLeftClass () {
      switch (this.type) {
        case 'info':
          return 'bg-blue-50 border-l-4 border-blue-400'
        case 'success':
          return 'bg-green-50 border-l-4 border-green-400'
        case 'warning':
          return 'bg-orange-50 border-l-4 border-orange-400'
        case 'error':
          return 'bg-red-50 border-l-4 border-red-400'
        default:
          return 'bg-blue-50 border-l-4 border-blue-400'
      }
    },
    iconColor () {
      switch (this.type) {
        case 'info':
          return 'text-blue-400'
        case 'success':
          return 'text-green-500'
        case 'warning':
          return 'text-orange-500'
        case 'error':
          return 'text-red-500'
        default:
          return 'text-blue-600'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
